export const UNDIFINED_PRODUCT_ID = 0; // productId is indexed from 1 so 0 is undefined.

export const parseProductId = (param?: string): number => {
    if (!param) {
        return UNDIFINED_PRODUCT_ID;
    }

    const parsed = parseInt(param, 10);

    return Number.isNaN(parsed) ? UNDIFINED_PRODUCT_ID : parsed;
};
